import * as finishContractReducer from './FinishContractReducer';

export function getReducer() {
    return finishContractReducer.getReducer();
}
